import React from 'react';

import { Checkbox } from '@/components/ui/checkbox';
import { CommandGroup, CommandItem } from '@/components/ui/command';
import { AvatarWithName } from '../../../../../../../shared/components/Avatar';
import { useAuth } from '../../../../../../../shared/hooks';
import { useDecedentFilters } from '../../../../hooks';
import NoOwnerItem from './NoOwnerItem';

const NO_OWNER_VALUE = 'null';

const OwnerList = () => {
  const {
    user: { id: currentUserId },
  } = useAuth();

  const {
    activeFilters,
    filterOptions: { owners },
    toggleFilter,
  } = useDecedentFilters();

  const buildLabel = (owner) =>
    currentUserId === owner.id ? `${owner.fullName} (me)` : owner.fullName;

  const isSelected = (value) => activeFilters.owners.includes(value);

  return (
    <CommandGroup>
      <NoOwnerItem
        isSelected={isSelected(NO_OWNER_VALUE)}
        onSelect={() => toggleFilter({ type: 'owners', value: NO_OWNER_VALUE })}
      />

      {owners.map((owner) => {
        const label = buildLabel(owner);

        return (
          <CommandItem
            key={owner.id}
            onSelect={() => toggleFilter({ type: 'owners', value: owner.id })}
            value={label}
          >
            <Checkbox checked={isSelected(owner.id)} />

            <AvatarWithName
              avatarColor={owner.avatarColor}
              fullName={label}
              initials={owner.initials}
            />
          </CommandItem>
        );
      })}
    </CommandGroup>
  );
};

export default OwnerList;
